<template>
  <div class="list-page">
    <div class="detail-banner">
      <div class="container">
        <h1>商务活动</h1>
        <div class="sub">点击卡片在新窗口打开活动详情</div>
      </div>
    </div>
    <section class="section">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div class="biz-tabs">
          <button
            class="biz-tab"
            :class="{ active: status === tab.code }"
            v-for="tab in tabs"
            :key="tab.code"
            @click="changeTab(tab.code)"
          >{{ tab.name }}</button>
        </div>

        <div class="card-grid" v-if="rows.length">
          <div
            v-for="item in rows"
            :key="item.id"
            class="card"
            @click="openLink(item)"
          >
            <div class="card-cover business-cover">
              <img v-if="item.cover" :src="item.cover" :alt="item.title" @error="onImgError" />
              <span v-else class="cover-letter">活动</span>
              <span class="biz-state" :class="String(item.status) === '0' ? 'ongoing' : 'ended'">
                {{ String(item.status) === '0' ? '进行中' : '已结束' }}
              </span>
            </div>
            <div class="card-body">
              <div class="card-title">{{ item.title }}</div>
              <div class="card-desc" v-if="item.startDate">活动日期：{{ item.startDate }} ~ {{ item.endDate }}</div>
              <div class="card-detail-btn">查看详情 ›</div>
            </div>
          </div>
        </div>

        <div class="empty-block" v-else-if="!loading">暂无{{ statusName }}活动</div>
        <div class="empty-block" v-else>加载中…</div>

        <div class="pager" v-if="totalPages > 1">
          <button class="pg-btn" :disabled="pageNum <= 1" @click="goPage(pageNum - 1)">‹ 上一页</button>
          <button
            v-for="p in pages"
            :key="p"
            class="pg-num"
            :class="{ active: p === pageNum }"
            @click="goPage(p)"
          >{{ p }}</button>
          <button class="pg-btn" :disabled="pageNum >= totalPages" @click="goPage(pageNum + 1)">下一页 ›</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { fetchBusinessPage } from '../api/home'

export default {
  name: 'BusinessList',
  data () {
    return {
      tabs: [
        { name: '进行中', code: '0' },
        { name: '已结束', code: '1' }
      ],
      status: '0',
      rows: [],
      pageNum: 1,
      pageSize: 8,
      total: 0,
      loading: true
    }
  },
  computed: {
    statusName () {
      const t = this.tabs.find(t => t.code === this.status)
      return t ? t.name : ''
    },
    totalPages () {
      return Math.max(1, Math.ceil(this.total / this.pageSize))
    },
    pages () {
      const tp = this.totalPages
      const cur = this.pageNum
      if (tp <= 7) return Array.from({ length: tp }, (_, i) => i + 1)
      const set = new Set([1, tp, cur, cur - 1, cur + 1, cur - 2, cur + 2])
      const arr = [...set].filter(p => p >= 1 && p <= tp).sort((a, b) => a - b)
      const out = []
      let prev = 0
      for (const p of arr) {
        if (p - prev > 1) out.push('...')
        out.push(p)
        prev = p
      }
      return out
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      this.loading = true
      try {
        const res = await fetchBusinessPage({
          status: this.status,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        this.rows = res.rows
        this.total = res.total
      } catch (e) {
        this.rows = []
        this.$toast.show({ message: (e && e.message) || '加载失败', type: 'error' })
      } finally {
        this.loading = false
      }
    },
    changeTab (code) {
      if (code === this.status) return
      this.status = code
      this.pageNum = 1
      this.load()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    openLink (item) {
      if (item.url) {
        window.open(item.url, '_blank')
      } else {
        this.$toast.show({ message: '该活动暂无可访问链接', type: 'error' })
      }
    },
    goPage (p) {
      if (p < 1 || p > this.totalPages || p === this.pageNum) return
      this.pageNum = p
      this.load()
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    onImgError (e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.business-cover {
  background: linear-gradient(135deg, #f0a04b, #d9772e);
  position: relative;
}
.biz-state {
  position: absolute;
  top: 10px;
  left: 10px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}
.biz-state.ongoing {
  background: #1f9d55;
}
.biz-state.ended {
  background: rgba(51, 65, 92, 0.78);
}
.biz-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
}
.biz-tab {
  padding: 9px 26px;
  border: 1px solid var(--border, #e6ebf5);
  background: #fff;
  color: var(--text-main, #33415c);
  border-radius: 22px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.biz-tab:hover {
  border-color: var(--primary, #2444cb);
  color: var(--primary, #2444cb);
}
.biz-tab.active {
  background: var(--primary, #2444cb);
  border-color: var(--primary, #2444cb);
  color: #fff;
}
.pager {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 34px;
  flex-wrap: wrap;
}
.pg-btn,
.pg-num {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--border, #e6ebf5);
  background: #fff;
  color: var(--text-main, #33415c);
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.pg-btn:hover:not(:disabled),
.pg-num:hover {
  border-color: var(--primary, #2444cb);
  color: var(--primary, #2444cb);
}
.pg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.pg-num.active {
  background: var(--primary, #2444cb);
  border-color: var(--primary, #2444cb);
  color: #fff;
}
.pager :not(button) {
  color: var(--text-sub, #9aa6c0);
  padding: 0 4px;
}
.empty-block {
  text-align: center;
  color: var(--text-sub, #9aa6c0);
  padding: 40px 0;
}
</style>
